import { InputLabels, InputErrors } from "../localisation";

export const FieldNotEmpty = (value, values, props, name) => {
  return (!value || value === "") && InputErrors.genericNoFieldPrefix + " " + InputLabels[name.split(".")[0]];
};
